import React, {useCallback} from 'react'
import {Section, SelectField, BoxDouble} from 'jbc-front/components/Form'
import {useDispatch, useSelector} from 'react-redux'
import {FormSection} from 'redux-form'
import {fetchSelector, actionCreators} from 'actions'
import api from 'api'
import {camelCase} from 'lodash'
import {prefectureOptions} from 'FormFields'
import {LabelMapper} from 'jbc-front/components/FormErrors'
import {useFetchEffect} from 'hooks/useFetchEffect'

const governmentOffices = {
  labor_standards_inspection_office_l: '労働基準監督署',
  hello_work: '公共職業安定所',
  pension_center: '年金事務所',
}
const governmentOfficeTypes = ['labor_standards_inspection_office_l', 'hello_work', 'pension_center']

const SubmissionDestination = ({autofill}) => {
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)

  const submissionDestination = useSelector((state) => fetchSelector(state, 'submission_destination_edit').data) || {}
  const officeOptions = useSelector((state) => {
    const result = {}
    governmentOfficeTypes.forEach((type) => {
      const key = camelCase(`${type}s`)
      const fetched = fetchSelector(state, `${type}s`)
      result[key] = (fetched && fetched.options) || []
    })
    return result
  })

  const loadOfficeGoverment = useCallback(
    (prefectureId, governmentOfficeType, token) => {
      dispatch(
        actionCreators.fetchData(
          `${governmentOfficeType}s`,
          prefectureId
            ? api
                .createWithAuth(token)
                .governmentOffices.list(prefectureId, governmentOfficeType)
                .then(({data}) => ({
                  options: data.map((office) => ({
                    value: office.submit_id,
                    label: office.disp_name,
                  })),
                }))
            : Promise.resolve({options: []})
        )
      )
    },
    [dispatch]
  )

  useFetchEffect(() => {
    governmentOfficeTypes.forEach((type) => {
      const prefectureId = submissionDestination[`${type}_prefecture_id`]
      if (prefectureId) {
        loadOfficeGoverment(prefectureId, type, token)
      }
    })
  }, [submissionDestination, token, loadOfficeGoverment])

  useFetchEffect(() => {
    return () => {
      governmentOfficeTypes.forEach((type) => {
        dispatch(actionCreators.fetchDestroy(`${type}s`))
      })
    }
  }, [dispatch])

  const handleChange = (type) => (event, value, previousValue) => {
    if (value !== previousValue) {
      dispatch(autofill(`submission_destination.${type}_submit_id`))
    }
    loadOfficeGoverment(value, type, token)
  }

  return (
    <Section title="届出の管轄">
      <FormSection name="submission_destination">
        <LabelMapper name="submission_destination" label="届出の管轄の" />
        <BoxDouble>
          {governmentOfficeTypes.map((type) => {
            const prefectureField = `${type}_prefecture_id`
            const submitField = `${type}_submit_id`
            const optionsKey = camelCase(`${type}s`)
            return (
              <React.Fragment key={type}>
                <SelectField
                  name={prefectureField}
                  label="都道府県"
                  options={prefectureOptions}
                  onChange={handleChange(type)}
                />
                <SelectField
                  name={submitField}
                  label={governmentOffices[type]}
                  options={officeOptions[optionsKey]}
                  required
                />
              </React.Fragment>
            )
          })}
        </BoxDouble>
      </FormSection>
    </Section>
  )
}

export default SubmissionDestination
